import React from "react";
import Modal from "../../ui-components/Modal";
import _ from "lodash";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import AuthenticationService from "../../services/AuthenticationService";

export function ConnectionsWorksiteModal(
  showWorksites,
  setShowWorksites,
  worksiteTypes,
  countryCode,
  intl
) {
  const userData = AuthenticationService.getUserData();

  const lkpType = worksiteTypes.reduce(
    (obj, i) => _.set(obj, [i.cod_worksite_type], i["icon_name"]),
    {}
  );

  return (
    <Modal onExit={() => setShowWorksites(undefined)}>
      <div className="flex w-full flex-col h-full">
        <label className="block text-lg font-bold mb-3">
          {intl.formatMessage({ id: "worksites" })}
        </label>
        {(showWorksites || []).map((i) => (
          <div className="grid grid-cols-6 my-2" key={i.id}>
            <div
              className="w-16 h-16 mb-2 bg-contain bg-center relative bg-no-repeat"
              style={{
                backgroundImage: `url(${lkpType[i.cod_worksite_type]})`,
                height: "40px",
                width: "40px",
              }}
            />
            <div className="col-span-4 capitalize">
              <span>{i.address} </span>
              <br />
              <span className="italic text-sm">
                {i.city} ({i.cod_province})
              </span>
            </div>
            <div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`/${countryCode}/worksites/${i.id}`}
              >
                <ArrowTopRightOnSquareIcon
                  className={`w-6 h-6 mt-2 text-${userData.business}-400 cursor-pointer`}
                />
              </a>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
}
